<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card v-if="element">
          <v-card-title>{{ element.name }}</v-card-title>
          <v-card-subtitle>{{ element.inventoryNumber }}</v-card-subtitle>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" lg="6">
                  <v-text-field
                    outlined
                    label="Numéro d'inventaire"
                    disabled
                    v-model="element.inventoryNumber"
                    dense
                  ></v-text-field>
                  <v-divider class="mb-7"></v-divider>
                  <div class="subtitle-2 mb-7">Entité</div>
                  <v-select
                    outlined
                    label="Entité*"
                    dense
                    :items="entities"
                    item-text="name"
                    item-value="_id"
                    v-model="element.entity"
                    :disabled="!admin"
                    :rules="[() => !!element.entity || 'Ce champ est requis.']"
                    required
                  ></v-select>
                  <v-text-field
                    outlined
                    label="Type"
                    disabled
                    dense
                    v-model="selectedEntity.type"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    label="Département"
                    disabled
                    dense
                    v-model="selectedEntity.department"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    label="Centre de coûts"
                    disabled
                    dense
                    v-model="selectedEntity.costCenter.name"
                  ></v-text-field>
                  <v-divider class="mb-7"></v-divider>
                  <div class="subtitle-2 mb-7">Emplacement</div>
                  <v-select
                    outlined
                    label="Emplacement"
                    dense
                    :items="places"
                    item-text="name"
                    item-value="_id"
                    v-model="element.place"
                    :disabled="!admin"
                  ></v-select>
                  <v-text-field
                    outlined
                    label="Salle"
                    disabled
                    dense
                    v-model="selectedPlace.room"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    label="Armoire"
                    disabled
                    dense
                    v-model="selectedPlace.cabinet"
                  ></v-text-field>
                  <v-divider class="mb-7"></v-divider>
                  <div class="subtitle-2 mb-7">Informations générales</div>
                  <v-select
                    outlined
                    label="Catégorie*"
                    dense
                    :items="categories"
                    item-text="name"
                    item-value="_id"
                    v-model="element.category"
                    :rules="[
                      () => !!element.category || 'Ce champ est requis.',
                    ]"
                    required
                    :disabled="!admin"
                  ></v-select>
                  <v-text-field
                    outlined
                    label="N° d'appareil"
                    dense
                    v-model="element.deviceNumber"
                    :disabled="!admin"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    label="Désignation*"
                    dense
                    v-model="element.name"
                    :rules="[() => !!element.name || 'Ce champ est requis.']"
                    required
                    :disabled="!admin"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    label="Marque"
                    dense
                    v-model="element.brand"
                    :disabled="!admin"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    label="Type"
                    dense
                    v-model="element.type"
                    :disabled="!admin"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    label="N° de série"
                    dense
                    v-model="element.businessId"
                    :disabled="!admin"
                  ></v-text-field>
                  <v-textarea
                    outlined
                    label="Fournisseur"
                    dense
                    v-model="element.supplier"
                    rows="1"
                    auto-grow
                    :disabled="!admin"
                  ></v-textarea>
                  <v-text-field
                    outlined
                    label="N° du BC"
                    dense
                    v-model="element.orderId"
                    :disabled="!admin"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    label="N° de facture"
                    dense
                    v-model="element.billingId"
                    :disabled="!admin"
                  ></v-text-field>
                  <v-menu
                    v-model="menu.billingDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formattedBillingDate"
                        label="Date de facture"
                        readonly
                        v-on="on"
                        clearable
                        outlined
                        dense
                        @input="clearDate('billingDate')"
                        :disabled="!admin"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      @input="
                        (val) => {
                          formatDate(val, 'billingDate');
                        }
                      "
                    ></v-date-picker>
                  </v-menu>
                  <v-text-field
                    outlined
                    label="Valeur*"
                    dense
                    type="number"
                    v-model="element.value"
                    :rules="[() => !!element.value || 'Ce champ est requis.']"
                    required
                    :disabled="!admin"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="6">
                  <div v-if="group" class="mb-7">
                    <div class="subtitle-2 mb-7">Groupe</div>
                    <v-text-field
                      outlined
                      label="Nom du groupe*"
                      dense
                      v-model="group.name"
                      :rules="[() => !!group.name || 'Ce champ est requis.']"
                      required
                      :disabled="!admin"
                    ></v-text-field>
                    <v-text-field
                      v-if="group._id !== 'tmp-group-id'"
                      outlined
                      label="Valeur globale"
                      dense
                      v-model="group.value"
                      disabled
                    ></v-text-field>
                    <div class="subtitle-2 mb-7">Éléments du groupe</div>
                    <div
                      v-for="groupElement in group.elements"
                      :key="groupElement._id"
                    >
                      <div v-if="groupElement._id !== element._id">
                        <span class="font-weight-bold">
                          <router-link :to="`/elements/${groupElement._id}`">{{
                            groupElement.inventoryNumber
                          }}</router-link>
                        </span>
                        <br />
                        {{ groupElement.name }}
                      </div>
                    </div>
                    <div class="text-center mt-5" v-if="admin">
                      <v-btn text small color="error" @click="removeFromGroup"
                        >Retirer du groupe</v-btn
                      >
                    </div>
                  </div>
                  <div v-else>
                    <div class="subtitle-2 mb-7">Groupe</div>
                    <v-autocomplete
                      v-model="element.group"
                      :items="elements"
                      :search-input.sync="search"
                      label="Lier un élément d'inventaire"
                      outlined
                      dense
                      no-data-text="Tapez la désignation d'un élément..."
                      @input="linkToGroup"
                      :disabled="!admin"
                    />
                  </div>
                  <v-divider class="mb-7"></v-divider>
                  <div class="subtitle-2 mb-7">Informations d'entrée</div>
                  <v-menu
                    v-model="menu.addedDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formattedAddedDate"
                        label="Date d'entrée"
                        readonly
                        v-on="on"
                        clearable
                        outlined
                        dense
                        @input="clearDate('addedDate')"
                        :disabled="!admin"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      @input="
                        (val) => {
                          formatDate(val, 'addedDate');
                        }
                      "
                    ></v-date-picker>
                  </v-menu>
                  <v-divider class="mb-7"></v-divider>
                  <div class="subtitle-2 mb-7">Informations de sortie</div>
                  <v-menu
                    v-model="menu.deletedDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formattedDeletedDate"
                        label="Date de sortie"
                        readonly
                        v-on="on"
                        clearable
                        outlined
                        dense
                        @input="clearDate('deletedDate')"
                        :disabled="!admin"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      @input="
                        (val) => {
                          formatDate(val, 'deletedDate');
                        }
                      "
                    ></v-date-picker>
                  </v-menu>
                  <v-select
                    v-model="element.inventoryDeletionCause"
                    outlined
                    label="Raison de sortie"
                    dense
                    :items="inventoryDeletionCauses"
                    item-text="name"
                    item-value="_id"
                    :disabled="!admin"
                  ></v-select>
                  <v-textarea
                    outlined
                    label="Commentaires de sortie"
                    dense
                    v-model="element.deletionComment"
                    rows="1"
                    auto-grow
                    :disabled="!admin"
                  ></v-textarea>
                  <v-divider class="mb-7"></v-divider>
                  <div class="subtitle-2 mb-7">Informations budgétaires</div>
                  <v-text-field
                    outlined
                    label="Responsable de projet"
                    dense
                    v-model="element.projectManager"
                    :disabled="!admin"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    label="N° de projet"
                    dense
                    v-model="element.projectId"
                    :disabled="!admin"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    label="N° d'ordre"
                    dense
                    v-model="element.commandId"
                    :disabled="!admin"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    label="Compte"
                    dense
                    v-model="element.account"
                    :disabled="!admin"
                  ></v-text-field>
                  <v-divider class="mb-7"></v-divider>
                  <div class="subtitle-2 mb-7">Illustration</div>
                  <div class="text-center">
                    <label for="image">
                      <input
                        type="file"
                        name="image"
                        id="image"
                        accept="image/*"
                        @change="uploadImage($event)"
                        style="display: none"
                        :disabled="!admin"
                      />
                      <img
                        style="border: solid gainsboro 1px; border-radius: 5px"
                        width="50%"
                        :src="
                          element.image
                            ? `${serverUrl}/images/${element.image}?token=${this.$keycloak.token}`
                            : add
                        "
                      />
                      <div v-if="element.image">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                              @click.stop.prevent="deleteImage"
                              v-if="admin"
                            >
                              <v-icon color="grey">mdi-cancel</v-icon>
                            </v-btn>
                          </template>
                          <span>Supprimer l'image</span>
                        </v-tooltip>
                      </div>
                    </label>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    outlined
                    label="Commentaires"
                    dense
                    v-model="element.comments"
                    rows="1"
                    auto-grow
                    :disabled="!admin"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions v-if="admin">
            <v-btn text @click="$router.go(-1)">Retour sans sauvegarder</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="error"
              v-if="this.$route.path.indexOf('/create') === -1"
              @click="openDeleteDialog"
              >Supprimer</v-btn
            >
            <v-btn
              text
              color="info"
              v-if="this.$route.path.indexOf('/create') === -1"
              :to="`/elements/${this.element._id}/create`"
              >Dupliquer</v-btn
            >
            <v-btn text color="info" :disabled="!validForm" @click="submitForm"
              >Sauvegarder</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-snackbar
          v-model="snackbar.visible"
          :bottom="true"
          :left="true"
          :color="snackbar.color"
        >
          {{ snackbar.text }}
          <v-btn dark text @click="snackbar.visible = false">Fermer</v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
    <delete-dialog
      :dialog="deleteDialog"
      :name="this.element.name"
      :_id="this.element._id"
      :inventoryNumber="this.element.inventoryNumber"
      :closeDialog="closeDeleteDialog"
    />
  </v-container>
</template>

<script>
import { format, formatISO, parse, parseISO } from "date-fns";
import _ from "lodash";
import axios from "axios";
import DeleteDialog from "@/components/DeleteDialog";
import add from "@/assets/add.png";

export default {
  components: {
    DeleteDialog,
  },
  props: [
    "categories",
    "costCenters",
    "entities",
    "inventoryDeletionCauses",
    "places",
    "element",
    "group",
    "selectedEntity",
    "selectedPlace",
    "admin",
    "prevRoute",
    "removeFromGroup",
    "linkToGroup",
  ],
  mounted() {
    if (
      this.prevRoute.indexOf("/create") > -1 &&
      this.prevRoute.split("/")[2] !== this.element._id
    ) {
      this.showSuccessSnackbar("Élement ajouté à l'inventaire");
    }
  },
  data: () => ({
    date: undefined,
    menu: {
      billingDate: false,
      addedDate: false,
      deletedDate: false,
    },
    elements: [],
    search: null,
    snackbar: {
      visible: false,
      color: "",
      text: "",
    },
    serverUrl: process.env.VUE_APP_API_URI,
    deleteDialog: false,
    add,
  }),
  watch: {
    "selectedEntity.name": function () {
      return (this.element.inventoryNumber = `${this.selectedEntity.name}-${this.element.deviceNumber}`);
    },
    "element.deviceNumber": function () {
      return (this.element.inventoryNumber = `${this.selectedEntity.name}-${this.element.deviceNumber}`);
    },
    search: _.debounce(function (val) {
      val && this.querySelections(val);
    }, 300),
  },
  computed: {
    formattedBillingDate: function () {
      if (this.element.billingDate) {
        return this.formatDateText(this.element.billingDate);
      }
      return "";
    },
    formattedAddedDate: function () {
      if (this.element.addedDate) {
        return this.formatDateText(this.element.addedDate);
      }
      return "";
    },
    formattedDeletedDate: function () {
      if (this.element.deletedDate) {
        return this.formatDateText(this.element.deletedDate);
      }
      return "";
    },
    validForm: function () {
      if (this.group) {
        return (
          !!this.element.entity &&
          !!this.element.category &&
          !!this.element.name &&
          typeof this.element.value !== "undefined" &&
          this.element.value !== "" &&
          this.group.name
        );
      }
      return (
        !!this.element.entity &&
        !!this.element.category &&
        !!this.element.name &&
        typeof this.element.value !== "undefined" &&
        this.element.value !== ""
      );
    },
  },
  methods: {
    formatDate: function (val, fieldName) {
      this.menu[fieldName] = false;
      this.element[fieldName] = formatISO(parse(val, "yyyy-MM-dd", new Date()));
    },
    formatDateText: function (val) {
      return format(parseISO(val, new Date()), "dd.MM.yyyy");
    },
    clearDate: function (val) {
      this.element[val] = "";
    },
    querySelections: async function (v) {
      this.loading = true;
      const { data: elements } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/elements/search?keywords=${v}&page=1&sort=name&filters=presents`,
      });
      this.elements = elements
        .filter((e) => e._id !== this.element._id)
        .map((e) => ({
          text: `${e.inventoryNumber} : ${e.name}`,
          value: JSON.stringify({
            group: e.group ? e.group._id : "tmp-group-id",
            element: e,
          }),
        }));
      this.loading = false;
    },
    showSuccessSnackbar: function (text) {
      this.snackbar.visible = true;
      this.snackbar.text = text;
      this.snackbar.color = "success";
    },
    submitForm: async function () {
      if (this.group && this.group._id) {
        if (this.group._id === "tmp-group-id") {
          const { data: group } = await axios({
            method: "post",
            url: `${process.env.VUE_APP_API_URI}/groups`,
            data: {
              name: this.group.name,
            },
          });
          this.element.group = group;
          this.group.elements[0].group = group;
          await axios({
            method: "patch",
            url: `${process.env.VUE_APP_API_URI}/elements/${this.group.elements[0]._id}`,
            data: {
              ...this.group.elements[0],
            },
          });
        } else {
          await axios({
            method: "patch",
            url: `${process.env.VUE_APP_API_URI}/groups/${this.group._id}`,
            data: {
              name: this.group.name,
            },
          });
        }
      }
      let method = "POST";
      let url = `${process.env.VUE_APP_API_URI}/elements`;
      if (this.$route.path.indexOf("/create") === -1) {
        method = "PATCH";
        url = `${process.env.VUE_APP_API_URI}/elements/${this.element._id}`;
      } else {
        this.element._id = undefined;
      }
      const { data: element } = await axios({
        method,
        url,
        data: {
          ...this.element,
        },
      });
      if (this.$route.path.indexOf("/create") > -1) {
        this.$router.push(`/elements/${element._id}`);
      } else {
        this.showSuccessSnackbar("Élement mis à jour");
      }
    },
    openDeleteDialog: function () {
      this.$router.push("#delete");
      this.deleteDialog = true;
    },
    closeDeleteDialog: function () {
      this.deleteDialog = false;
      this.$router.push("");
    },
    uploadImage: async function (event) {
      const formData = new FormData();
      formData.append("image", event.target.files[0]);
      const { data } = await axios({
        method: "post",
        url: `${process.env.VUE_APP_API_URI}/upload`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      this.element.image = data._id;
    },
    deleteImage: function () {
      this.element.image = null;
    },
  },
};
</script>